<template>
	<h3 class="text-2xl font-bold">FAQ</h3>
    <h4 class="font-bold text-lg mt-2">
        What is the Server IP for {{ server.title }}?
    </h4>
    <p class="text-sm mt-2 font-normal">
        The IP for the {{ server.title }} is:
        <span class="font-bold">{{
                server.ip + (server.port !== 25565 ? ":" + server.port : "")
            }}</span>
    </p>
	<h4 class="font-bold text-lg mt-3.5">
        What Game modes can I play on {{ server.title }}?
	</h4>
	<p class="text-sm mt-2 font-normal">
        On {{ server.title }} you can enjoy the following game modes:
    </p>
    <div class="flex gap-2 flex-wrap mt-2">
        <NuxtLink
                v-for="tag in tags"
                :key="tag.name"
                :href="'/server-tags/' + tag.urlname"
                class="bg-blue-100 px-1 py-0.5 text-sm hover:bg-blue-150"
        >
            {{ tag.name }}
        </NuxtLink>
    </div>
	<h4 class="font-bold text-lg mt-3.5">
        What versions does the {{ server.title }} server support?
	</h4>
	<p class="text-sm mt-2 font-normal">
        {{ server.title }} currently supports versions: {{ server.status?.version?.name ?? "?" }}
    </p>
</template>

<script setup>
const props = defineProps({
    server: {
        type: Object,
        required: true,
    },
    tags: {
        type: Array,
        required: true,
    }
});
</script>